import axios from 'axios';

const PREFIJO="/api/MpPMt/";

export default {
  listado(){
    return axios.post(`${PREFIJO}VmSlMpm`);
  },
};
